module.exports = __webpack_public_path__ + "img/old-company-value.54724a17.png";